<template>
    <h1 class="has-text-centered">Image Gallery</h1>
    <div>
        <LoadingSpinner v-if="isLoading" class="m-3"></LoadingSpinner>
        <div v-else-if="error">{{ error }}</div>
        <div v-else>
            <!-- Display images side by side in rows -->
            <div class="columns is-multiline">
                <div class="column is-6-fullhd" v-for="object in images" :key="object.Key">
                    <div class="card is-shadow-none">
                        <section class="card has-text-white has-background-dark" style="border-radius: 20px;">
                            <div class="card-image cover-long-image is-overflow-hidden"
                                 style="border-top-left-radius:20px; border-top-right-radius:20px;">
                                    <img :src="object.url" alt="Image">
                            </div>
                            <div class="card-content px-0 py-5">
                                <div class="level">
                                    <div @click="insertImage(object)" class="m-5 button level-item has-text-centered is-primary">Insert Image</div>
                                    <div @click="insertPrimaryImage(object)" class="m-5 button level-item has-text-centered level-item is-light">Set as Primary Image</div>
                                    <div @click="deleteImage(object)" class="m-5 button level-item has-text-centered level-item is-danger">Delete Image</div>
                                </div>
                                <h2 class="is-flex is-justify-content-center has-text-white mt-5">{{ object.filename }}</h2>
                            </div>
                        </section>
                        <div class="section"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getS3Files, deleteFile } from "@/js/uploader.js"
import LoadingSpinner from "@/widgets/LoadingSpinner.vue"
import { deleteBeforeFinalSlash } from "@/js/general.js"

export default {
    name: 'Gallery',
    data() {
        return {
            isLoading: false,
            error: '',
            images: [],
        }
    },
    emits: ['imageObject', 'primaryImageObject', 'imagesRefreshed'],
    props: ['refreshImages'],
    methods: {
        async fetchS3Objects() {
            this.isLoading = true
            console.log('refreshing images')
            try {
                this.images = await getS3Files('imgs', ['image/png', 'image/jpeg'])
                this.images = deleteBeforeFinalSlash(this.images)
                this.isLoading = false
                console.log('images refreshed')
            }
            catch (error) {
                this.error = "Error fetching S3 objects"
                this.isLoading = false
            }
        },
        insertImage(imageObject) {
            this.$emit('imageObject', imageObject)
        },
        insertPrimaryImage(imageObject) {
            this.$emit('primaryImageObject', imageObject)
        },
        async deleteImage(object) {
            await deleteFile(process.env.VUE_APP_BUCKET_BLOG, object.Key)
            this.fetchS3Objects()
        }
    },
    mounted() {
        this.fetchS3Objects()
    },
    watch: {
        refreshImages() {
            if (this.refreshImages) {
                this.fetchS3Objects()
                this.$emit('imagesRefreshed')
            }
        }
    },
    components: { LoadingSpinner }
}
</script>

<style>
body {
    color: #333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.cover-long-image {
    max-height: 450px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.cover-long-image img {
    transition: transform 1s, filter 2s ease-in-out;
    -webkit-transition: transform 1s, filter 2s ease-in-out;
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
}

.card:hover .cover-long-image img {
    cursor: pointer;
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
}

.has-w-full {
    width: 100%;
}

.has-text-orange {
    color: #ff8300;
}

.is-shadow-none {
    box-shadow: none !important;
}

.is-overflow-hidden {
    overflow: hidden !important;
}

</style>

